import type { FC, MouseEvent as ReactMouseEvent } from 'react';

import { BodyText, SectionTitle } from './commonComponents';

type CookieDescriptionProps = {
	handleCookieNoticeClick: (e: ReactMouseEvent) => void;
};

export const CookieDescription: FC<CookieDescriptionProps> = ({ handleCookieNoticeClick }) => (
	<>
		<BodyText variant="subtitle1">
			Cookies are small pieces of data that websites store on your browser when you visit them. Cookies are useful
			because they allow a website to recognise your visit and collect information about how you use that website.
		</BodyText>
		<BodyText variant="subtitle1">
			You can choose which types of optional cookies you wish to accept. You can manage these preferences at any time
			bellow.
		</BodyText>
		<BodyText variant="subtitle1">
			Please also see our{' '}
			<span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleCookieNoticeClick}>
				Cookie notice
			</span>{' '}
			for more information.
		</BodyText>
		<SectionTitle sx={{ fontWeight: 500, position: 'relative' }} variant="h6">
			Strictly necessary cookies
		</SectionTitle>
		<BodyText variant="subtitle1">
			Strictly necessary cookies ensure that our website is able to function properly, and include cookies that help you
			log in, that provide core services and features, that help keep our website secure and that help us detect fraud
			or crime. We don’t have to ask for your consent to store these cookies on your browser. We've listed the
			categories of this strictly necessary cokies in our{' '}
			<span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleCookieNoticeClick}>
				Cookie notice
			</span>
			.
		</BodyText>
		<SectionTitle sx={{ fontWeight: 500, position: 'relative' }} variant="h6">
			Optional cookies
		</SectionTitle>
		<BodyText variant="subtitle1">
			We’d also like to use cookies to provide optional features, improve our website and support our marketing. Where
			relevant, our trusted partners will help us make use of these optional cookies.
		</BodyText>
		<BodyText variant="subtitle1">
			To make it easier to choose which optional cookies to accept, we’ve organised these cookies by categories. They
			are set out below.
		</BodyText>
	</>
);
